import './tab-navigation.scss';

import AjaxLoad from '../../utilities/js/ajax-load';
import { createElementFromHTML, checkAndLoadFiles, smoothScrollTo, getOffset } from '../../utilities/js/helper';
import Swiper from 'swiper';
import { Navigation, Mousewheel } from 'swiper/modules';
import 'swiper/scss';
import 'swiper/scss/navigation';
import 'swiper/scss/mousewheel';

class TabNavigation {
    constructor (element) {
        this.$tabNav = element;
        this.$tabNavItems = element.querySelectorAll('[data-tab-nav="item"]');
        this.$sliderContainer = element.querySelector('[data-tab-nav="slider"]');
        this.$targetWrapper = element.nextElementSibling;
        this.$target = this.$targetWrapper.querySelector('[data-tab-nav="target"]');
        this.$activeTab = this.$sliderContainer.querySelector('[data-tab-nav="item"].is--active');
        this.ajaxActive = false;
        this.tabNavName = this.$tabNav.dataset.tabNavName;
        this.loader = null;
        this.store = [];
        this.$tabMainDocument = element.querySelector('[data-tab-nav-main]');
        this.$elementToHide = document.querySelector('[data-tab-nav="hide"]');
        this.slider = null;
        this.onBoardSubpage = null;
        this.waitTimeout = null;
        this.$header = document.querySelector('[data-header="root"]');
    }

    initialize () {
        if (this.$tabMainDocument) {
            this.store[0] = this.$target.children;
        }

        if (typeof onBoardSubpage !== 'undefined') {
            this.onBoardSubpage = this.$tabNav.dataset.tabNavType ? onBoardSubpage : null; // eslint-disable-line
        }

        if (!this.$target) {
            this.$target = document.querySelector('[data-tab-nav="target"]');
        }

        this.$tabNav.classList.add('is--init');

        if (this.onBoardSubpage) {
            this.checkForSubpage();
        }

        if (this.$activeTab && !this.$tabMainDocument) {
            this.checkBeforeSubmit(this.$activeTab.getAttribute('data-tab-nav-url'), this.$activeTab, false);
        }

        if (this.$tabNavItems.length > 0 && this.$target) {
            this.initSlider();
            this.setEvents();
        }
    }

    checkForSubpage () {
        this.$activeTab.classList.remove('is--active');
        this.$activeTab = this.$sliderContainer.querySelector('[data-tab-nav-url="' + this.onBoardSubpage + '"]');
        this.$activeTab.classList.add('is--active');
        this.onBoardSubpage = null;
    }

    setEvents () {
        this.$tabNavItems.forEach((item, index) => {
            item.addEventListener('click', () => {
                this.checkBeforeSubmit(item.getAttribute('data-tab-nav-url'), item);
            });
        });
    }

    checkBeforeSubmit (url, item, scroll = true) {
        if (scroll === true) {
            this.scrollToTabNavigation();
        }

        if (this.ajaxActive === false) {
            if (item !== this.$activeTab) {
                const $activeTab = this.$sliderContainer.querySelector('[data-tab-nav="item"].is--active');

                if ($activeTab) {
                    $activeTab.classList.remove('is--active');
                    item.classList.add('is--active');
                    this.$activeTab = item;
                }
            }
            this.ajaxActive = true;
            this.loader = createElementFromHTML(window.OPTIONS.loader);
            this.$targetWrapper.prepend(this.loader);
            this.$targetWrapper.classList.remove('is--visible');

            if (item.dataset.tabNavMain === undefined) {
                this.sendRequest(url);

                if (this.$elementToHide) {
                    this.$elementToHide.classList.add('is--fade-out');

                    this.waitTimeout = setTimeout(() => {
                        this.$elementToHide.classList.add('is--hidden');
                        this.$elementToHide.classList.remove('is--fade-in');
                        this.waitTimeout = null;
                    }, 1000);
                }
            } else {
                if (this.waitTimeout !== null) {
                    clearTimeout(this.waitTimeout);
                    this.waitTimeout = null;
                }
                this.resetToMain();
            }
        } else {
            console.log('Please wait.....Ajax is running');
        }
    }

    resetToMain () {
        if (this.$elementToHide) {
            this.$elementToHide.classList.remove('is--hidden');
            this.$elementToHide.classList.add('is--fade-in');

            setTimeout(() => {
                this.$elementToHide.classList.remove('is--fade-out');
                this.ajaxActive = false;
            }, 200);

            this.$target.style.height = '0';
            this.$target.innerHTML = '';

            if (this.loader) {
                this.loader.remove();
                this.loader = null;
            }

            setTimeout(() => {
                this.$target.style.height = 'auto';
                const $loading = this.$targetWrapper.querySelector('.loading');

                if ($loading) {
                    $loading.remove();
                }
            }, 200);
        }
    }

    sendRequest (url) {
        this.result = new AjaxLoad(url, {
            requestMethod: 'post',
            onSuccess: (resultText) => {
                // const results = JSON.parse(resultText);
                this.setResult(resultText);
            },
            onError: (error) => {
                console.warn(error);
            }
        });
    }

    setResult (results) {
        let $result = createElementFromHTML(results);

        this.$target.style.height = this.$target.scrollHeight + 'px';

        this.$target.replaceChildren();

        if (this.loader) {
            this.loader.classList.add('is--hidden');
        }

        if (this.tabNavName) {
            const $tabTarget = $result.querySelector('[data-tab-nav-content="' + this.tabNavName + '"');

            if ($tabTarget) {
                $result = $tabTarget;
            }
        }

        if ($result.length > 1) {
            $result.forEach((item) => {
                this.$target.appendChild(item);
            });
        } else {
            this.$target.appendChild($result);
        }

        checkAndLoadFiles(this.$target).then((data) => {
            console.log(data);

            window.dispatchEvent(new CustomEvent('content.loaded', {
                view: window,
                bubbles: true,
                cancelable: false,
                detail: {
                    $context: this.$target,
                    ajax: true
                }
            }));
        });

        setTimeout(() => {
            this.$target.style.height = $result.scrollHeight + 'px';
        }, 50);

        setTimeout(() => {
            this.$targetWrapper.classList.add('is--visible');
        }, 250);

        setTimeout(() => {
            this.$target.style.height = 'auto';

            if (this.loader) {
                this.loader.remove();
                this.loader = null;
            }
            this.ajaxActive = false;
        }, 550);

        window.bookmark.initialize(this.$target);

        const dataInview = this.$target.querySelectorAll('[data-inview]:not(.inview)');
        setTimeout(() => {
            dataInview.forEach((dataInView) => {
                window.inViewObserver.observe(dataInView);
            });
        }, 100);
    }

    scrollToTabNavigation () {
        let offset = this.$tabNav.offsetHeight;
        if (this.$header) {
            offset = offset + this.$header.offsetHeight;
        }

        const anchorDimensions = getOffset(this.$targetWrapper);
        const anchorDimensionsTop = anchorDimensions.top;

        smoothScrollTo(0, anchorDimensionsTop - offset, 500);
    }

    initSlider () {
        this.slider = new Swiper(this.$sliderContainer, {
            modules: [Navigation, Mousewheel],
            slidesPerView: 'auto',
            speed: 500,
            autoHeight: false,
            resistanceRatio: 0,
            threshold: 10,
            slideToClickedSlide: true,
            mousewheel: {
                forceToAxis: true
            },
            navigation: {
                nextEl: this.$sliderContainer.querySelector('.tab-nav__next'),
                prevEl: this.$sliderContainer.querySelector('.tab-nav__prev')
            }
        });
    }
}

export { TabNavigation };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $tabNavs = $context.querySelectorAll('[data-tab-nav="root"]:not(.is--init)');
        for (let i = 0; i < $tabNavs.length; i++) {
            const $tabNav = new TabNavigation($tabNavs[i]);
            $tabNav.initialize();
        }
    }
});
